import Modal from '../modal/modal';

export default new class ModalJournalContent {
  constructor() {
    this.journalContentModalLink = 'js-modal-journal-content';
    this.journalArchiveModalLink = 'js-modal-journal-archive';
    this.initBindings();
  }

  initBindings() {
    $(document).on('touchstart click', `.${this.journalContentModalLink}`, (e) => {
      e.preventDefault();

      const $clickedLink = $(e.currentTarget);
      const targetDataValue = $clickedLink.data('modal-link');
      const iJournalID = $clickedLink.attr('data-id');
      const sSubjournal = $clickedLink.attr('data-zhurnal');

      $.request('JournalData::onAjaxRequest', {
        data: {
          journal_id: iJournalID,
          subjournal: sSubjournal,
        },
        update: {
          'project/common/modal-journal-content/modal-journal-content': '.modal-journal-content',
        },
        complete() {
          Modal.openModal($clickedLink, $(`.${Modal.modalContent}[data-modal='${targetDataValue}']`));
        },
      });
    });

    $(document).on('touchstart click', `.${this.journalArchiveModalLink}`, (e) => {
      const $clickedLink = $(e.currentTarget);
      const targetDataValue = $clickedLink.data('modal-link');

      $.request('JournalData::onAjaxRequest', {
        data: {
          year: $clickedLink.attr('data-year'),
          subjournal: $clickedLink.attr('data-zhurnal'),
        },
        update: {
          'project/common/modal-journal-archive/modal-journal-archive': '.modal-journal-archive',
        },
        complete() {
          Modal.openModal($clickedLink, $(`.${Modal.modalContent}[data-modal='${targetDataValue}']`));
        },
      });
    });
  }
}();
